import { combineReducers } from "redux";

import numAjaxCallsInProgress from "./ajaxStatusReducer";
import calendarSettings from "./calendarSettingsReducer";
import addOrEditEvent from "./eventAddOrEditReducer";
import currentEvent from "./eventDetailReducer";
import events from "./eventViewReducer";
import recurrenceSettings from "./recurrenceReducer";
import searchToolbar from "./searchToolbarReducer";
import selectEventsFromOtherCalendarsSettings from "./selectEventsFromOtherCalendarsReducer";
import text from "./textReducer";
import width from "./widthReducer";

const rootReducer = combineReducers( {
  numAjaxCallsInProgress,
  calendarSettings,
  currentEvent,
  addOrEditEvent,
  events,
  searchToolbar,
  text,
  width,
  selectEventsFromOtherCalendarsSettings,
  recurrenceSettings,
});

export default rootReducer;
